/**
 * Force l'ouverture dans un nouvel onglet pour les liens vers veronikaloubryparfum.com
 * Ce script s'exécute avant les autres handlers pour garantir que le lien s'ouvre dans un nouvel onglet
 */
(function() {
  'use strict';

  function forceExternalLink() {
    // Sélectionner tous les liens du menu qui pointent vers veronikaloubryparfum.com
    const menuLinks = document.querySelectorAll('a[href*="veronikaloubryparfum"]');
    
    menuLinks.forEach(function(link) {
      // S'assurer que target="_blank" est présent
      if (!link.hasAttribute('target')) {
        link.setAttribute('target', '_blank');
        link.setAttribute('rel', 'noopener noreferrer');
      }
      
      // Ajouter une classe pour identification
      link.classList.add('external-link-veronika');
      
      // Intercepter le clic AVANT les autres handlers
      link.addEventListener('click', function(e) {
        const href = this.getAttribute('href');
        
        // Si c'est bien un lien externe vers veronikaloubryparfum
        if (href && href.includes('veronikaloubryparfum')) {
          // Empêcher le comportement par défaut et les autres handlers
          e.stopImmediatePropagation();
          e.preventDefault();
          
          // Ouvrir dans un nouvel onglet
          window.open(href, '_blank', 'noopener,noreferrer');
          
          return false;
        }
      }, true); // Utiliser capture phase pour intercepter AVANT les autres handlers
    });
  }

  // Exécuter au chargement du DOM
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', forceExternalLink);
  } else {
    forceExternalLink();
  }

  // Ré-exécuter après les chargements AJAX du menu (pour les menus dynamiques)
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.addedNodes.length) {
        forceExternalLink();
      }
    });
  });

  // Observer les changements dans les zones de navigation
  const navContainers = document.querySelectorAll('[data-navigation], [data-navigation-mobile], #HeaderNavigation, .header__inline-menu');
  navContainers.forEach(function(container) {
    observer.observe(container, {
      childList: true,
      subtree: true
    });
  });
})();

